<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col md="12">
        <b-row>
          <b-col md="6">
            <h4>Delivery Setup Details</h4>
          </b-col>
          <b-col md="6">
            <eb-button
              classic="mr-1 btn-primary"
              style="color: white; font-weight: bold; float: right"
              text="Back"
              @click="(e) => $emit('view', e)"
            ></eb-button>
          </b-col>
        </b-row>
        <b-card class="Account-card mt-3" height="157">
          <b-row class="m-2">
            <b-col md="3">
              <b-row>
                <h4>State :</h4>
                <h5 class="ml-1 text-muted">{{ inputObject.state }}</h5>
              </b-row>
            </b-col>
            <b-col md="3">
              <b-row>
                <h4>City :</h4>
                <h5 class="ml-1 text-muted">{{ inputObject.city }}</h5>
              </b-row>
            </b-col>
            <b-col md="3">
              <b-row>
                <h4>Area :</h4>
                <h4 class="ml-1 text-muted">{{ inputObject.areacode }}</h4>
              </b-row>
            </b-col>
            <b-col md="3">
              <b-row>
                <h4>Transport Mode :</h4>
                <h4 class="ml-1 text-muted">
                  {{ inputObject.transportMode }}
                </h4>
              </b-row>
            </b-col>
            <!-- <b-col md="3">
              <b-row>
                <h4>Start Date :</h4>
                <h4 class="ml-1  text-muted">{{ inputObject.startDate }}</h4>
              </b-row>
            </b-col> -->
          </b-row>
          <b-row class="m-2 p-0">
            <b-col md="3">
              <b-row>
                <h4>Start Date :</h4>
                <h4 class="ml-1 text-muted">{{ inputObject.startDate }}</h4>
              </b-row>
            </b-col>
            <b-col md="3">
              <b-row>
                <h4>End Date :</h4>
                <h4 class="ml-1 text-muted">{{ inputObject.endDate }}</h4>
              </b-row>
            </b-col>
            <b-col md="3">
              <b-row>
                <h4>Category :</h4>
                <h4 class="ml-1 text-muted">{{ inputObject.category }}</h4>
              </b-row>
            </b-col>
            <b-col md="3">
              <b-row>
                <h4>Rank :</h4>
                <h4 class="ml-1 text-muted">{{ inputObject.rank }}</h4>
              </b-row>
            </b-col>
            <b-col md="3">
              <b-row>
                <h4>Default charge :</h4>
                <h4 class="ml-1 text-muted">{{ inputObject.dwf }}</h4>
              </b-row>
            </b-col>

            <b-col md="3">
              <b-row>
                <h4>Delivery Owner :</h4>
                <h4 class="ml-1 text-muted">
                  {{ inputObject.deliveryOwner }}
                </h4>
              </b-row>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
    <div>
      <b-row>
        <b-col md="8">
          <h4>Distance Tier</h4>
        </b-col>
      </b-row>
      <div v-for="(t, idx) in inputObject.distanceTier" :key="idx">
        <v-card class="mt-1 mb-3">
          <b-row style="background-color: #767bf1" class="m-0">
            <b-col md="6">
              <h4 class="text-white">
                Distance Tier Name : {{ inputObject.distanceTier[idx].tier }}
              </h4>
            </b-col>
            <b-col md="2"></b-col>
            <b-col md="2">
              <h4 class="text-white">
                Start Range(KM) : {{ inputObject.distanceTier[idx].from }}
              </h4>
            </b-col>
            <b-col md="2">
              <h4 class="text-white">
                End Range(KM) : {{ inputObject.distanceTier[idx].to }}
              </h4>
            </b-col>
          </b-row>
          <b-row
            v-for="(p, wIdx) in inputObject.distanceTier[idx].weight"
            :key="wIdx"
            class="p-0 m-2"
          >
            <b-col>
              <b-row>
                <label class="mr-1"><b>Start Range (KG) : </b></label>
                {{ inputObject.distanceTier[idx].weight[wIdx].from }}
              </b-row>
            </b-col>
            <b-col>
              <b-row>
                <label class="mr-1"><b>End Range (KG) : </b></label>

                {{ inputObject.distanceTier[idx].weight[wIdx].to }}
              </b-row>
            </b-col>

            <b-col>
              <b-row>
                <label class="mr-1"><b>Time : </b></label>
                {{
                  inputObject.distanceTier[idx].weight[wIdx].etd
                    ? inputObject.distanceTier[idx].weight[wIdx].etd.time
                    : ""
                }}
                {{
                  inputObject.distanceTier[idx].weight[wIdx].etd
                    ? inputObject.distanceTier[idx].weight[wIdx].etd.uom
                    : ""
                }}
              </b-row>
            </b-col>
            <b-col>
              <b-row>
                <label class="mr-1"><b>Customer Cost : </b></label>

                {{ inputObject.distanceTier[idx].weight[wIdx].customerFee }}
              </b-row>
            </b-col>

            <b-col>
              <b-row>
                <label class="mr-1"><b>Delivery Cost : </b></label>
                {{
                  inputObject.distanceTier[idx].weight[wIdx].deliveryAgentFee
                }}
              </b-row>
            </b-col>
          </b-row>
        </v-card>
      </div>
    </div>
  </div>
</template>
<script>
import cInput from "@/components/Common/CustomInput";
import ebButton from "@/components/FormElements/Button";
import currentUser from "@/mixins/currentUser";
export default {
  mixins: [currentUser],
  components: {
    cInput,
    ebButton,
  },
  data() {
    return {
      inputObject: {
        city: "",
        state: "",
        category: "",
        transportMode: "",
        startDate: "",
        endDate: "",
        rank: "",
        areacode: "",
        dwf: "",
        deliveryOwner: "",
        distanceTier: [
          {
            tier: "",
            from: "",
            to: "",
            isRemovable: false,
            weight: [
              {
                from: "",
                to: "",
                customerFee: "",
                deliveryAgentFee: "",
                isRemovable: false,
              },
            ],
          },
        ],
      },
    };
  },
  props: {
    details: {
      type: Object,
      required: true,
    },
  },
  computed: {},
  async mounted() {
    (this.inputObject.city =
      this.$props.details.city == "*"
        ? "All cities"
        : this.$props.details.city),
      (this.inputObject.state =
        this.$props.details.state == "*"
          ? "All states"
          : this.$props.details.state),
      (this.inputObject.transportMode = this.$props.details.transportMode),
      //(this.inputObject.category = this.$props.details.category),
      (this.inputObject.startDate = this.$props.details.StartDate),
      (this.inputObject.endDate = this.$props.details.EndDate),
      (this.inputObject.rank = this.$props.details.rank),
      (this.inputObject.dwf = this.$props.details.dwf);
    (this.inputObject.areacode = this.$props.details.areaCode),
      (this.inputObject.deliveryOwner = this.$props.details.deliveryOwner.name),
      (this.inputObject.distanceTier = this.$props.details.distance);

    if (this.$userRole == "Tenant") {
      if (!this.$store.getters["catalog/GetTenantCatalogTree"].length > 0) {
        await this.$store.dispatch("catalog/fetchTenantCatalogTree");
      } else {
      }
    } else if (this.$userRole == "Partner") {
      if (!this.$store.getters["catalog/GetPartnerCatalogTree"].length > 0) {
        await this.$store.dispatch("catalog/fetchPartnerCatalogTree");
      } else {
      }
    }

    if (this.$userRole == "Tenant") {
      if (this.$store.getters["catalog/GetTenantCatalogTree"].length > 0) {
        let filtredList = this.$store.getters[
          "catalog/GetTenantCatalogTree"
        ].filter((obj) => {
          return this.$props.details.category_id == obj._id;
        });

        if (filtredList.length > 0) {
          this.inputObject.category = filtredList[0].name
            ? filtredList[0].name
            : "*";
        } else {
          this.inputObject.category = "All categories";
        }
      }
    } else if (this.$userRole == "Partner") {
      if (this.$store.getters["catalog/GetPartnerCatalogTree"].length > 0) {
        let filtredList = this.$store.getters[
          "catalog/GetPartnerCatalogTree"
        ].filter((obj) => {
          return this.$props.details.category_id == obj._id;
        });

        if (filtredList.length > 0) {
          this.inputObject.category = filtredList[0].name
            ? filtredList[0].name
            : "*";
        } else {
          this.inputObject.category = "All categories";
        }
      }
    }
  },
  methods: {},
};
</script>

<style scoped>
p {
  font-size: 13px;
}
.Account-card {
  background-color: #ffffff;
  padding-top: 0px;
  border-radius: 15px;
}
table {
  border-collapse: collapse;
  border-spacing: 0;
  width: 100%;
}
th,
td {
  padding: 8px;
  color: #000000;
  font-weight: bold;
}
th {
  width: 46%;
  color: #8f8f8f;
}
</style>
